// CONSTANTS are all caps.
const NS = 'ReactAppointmentsContainer';
const CLS = 'reactAppointmentsContainer';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import rReactAppointmentsContainer from './ReactAppointmentsContainer.jsx';
import React from 'react';
import ReactDOM from 'react-dom';

const defaultProps = {};

export class ReactAppointmentsContainer {

	constructor(el) {
		// $el is the blk node return by the loadReactAppointmentsContainer function
		this.el = el;
		this.upcomingApi = $(this.el).data('upcomingApi');
		this.pastApi = $(this.el).data('pastApi');
		this.init();
	}

	init() {
		this.setReactAppointmentsContainer();
	}

	setReactAppointmentsContainer() {
		// Add Some logic here
		ReactDOM.render(
			React.createElement(rReactAppointmentsContainer, {
				upcomingApi: this.upcomingApi,
				pastApi: this.pastApi,
			}),
			this.el
		);
	}

	// Add more functions like on above here
}
